module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 5